import React from 'react';

/**
 * Skeleton Loader component for showing placeholder content while data is loading
 * Improves perceived performance with animated placeholder content
 */
function SkeletonLoader({ count = 1, variant = 'card', className = '' }) {
  if (variant === 'stat-card') {
    return (
      <div className={`bg-gray-100 rounded-lg p-6 animate-pulse ${className}`}>
        <div className="h-4 bg-gray-200 rounded w-24 mb-4"></div>
        <div className="h-8 bg-gray-200 rounded w-32 mb-2"></div>
        <div className="h-3 bg-gray-200 rounded w-20"></div>
      </div>
    );
  }

  if (variant === 'chart') {
    return (
      <div className={`bg-white rounded-lg shadow p-6 animate-pulse ${className}`}>
        <div className="h-5 bg-gray-200 rounded w-32 mb-6"></div>
        <div className="space-y-3">
          <div className="h-32 bg-gray-200 rounded"></div>
        </div>
      </div>
    );
  }

  if (variant === 'image') {
    return (
      <div className={`bg-gray-200 rounded-lg animate-pulse ${className}`}></div>
    );
  }

  if (variant === 'card') {
    return (
      <div className={`bg-white rounded-lg shadow overflow-hidden animate-pulse ${className}`}>
        <div className="h-48 bg-gray-200"></div>
        <div className="p-4">
          <div className="h-4 bg-gray-200 rounded w-32 mb-3"></div>
          <div className="h-6 bg-gray-200 rounded w-24 mb-4"></div>
          <div className="h-3 bg-gray-200 rounded w-full mb-2"></div>
          <div className="h-3 bg-gray-200 rounded w-3/4"></div>
          <div className="flex gap-2 pt-3 mt-3 border-t border-gray-200">
            <div className="flex-1 h-8 bg-gray-200 rounded"></div>
            <div className="flex-1 h-8 bg-gray-200 rounded"></div>
            <div className="w-8 h-8 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>
    );
  }

  if (variant === 'text-line') {
    return <div className={`h-4 bg-gray-200 rounded animate-pulse ${className}`}></div>;
  }

  // Default: render multiple skeleton items
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className={`bg-white rounded-lg shadow overflow-hidden animate-pulse ${className}`}>
          <div className="h-48 bg-gray-200"></div>
          <div className="p-4">
            <div className="h-4 bg-gray-200 rounded w-32 mb-3"></div>
            <div className="h-6 bg-gray-200 rounded w-24 mb-4"></div>
            <div className="h-3 bg-gray-200 rounded w-full mb-2"></div>
            <div className="h-3 bg-gray-200 rounded w-3/4"></div>
          </div>
        </div>
      ))}
    </>
  );
}

export default SkeletonLoader;
